import React from 'react';
import { useSelector } from 'react-redux'
import CouponContainer from '../../coupon/containers/CouponContainer';
import TicketPickerPage from './TicketPickerPage';
import { showPresaleCouponForm } from '../../coupon/selectors/coupon';
import { MemberLogin } from "@b/listing/components/MemberLogin";

const EmbeddedTicketPicker = props => {
    const isCouponRoute = useSelector(state => state.ui.currentRouteName === 'coupon');
    const overlay       = useSelector(state => !!state.ui.overlay);
    const showPresale   = useSelector(state => showPresaleCouponForm(state));

    const isMembershipAvailable = !!useSelector(state => state.ui?.uiConfig?.membershipFormConfig?.membership_available);
    const isMembershipSkipped = !!useSelector(state => state.ui?.skipMembership);
    const hasMembershipInstance = !!useSelector(state => state.reservation?.hasMembershipInstance);

    const showMembership = isMembershipAvailable && !isMembershipSkipped && !hasMembershipInstance;
    const showCouponContainer = (isCouponRoute || showPresale) && !overlay;

    if (showMembership) {
      return <MemberLogin />;
    }

    return (showCouponContainer)
      ? <CouponContainer asOverlay={false} canCancelPresale={false}/>
      : <TicketPickerPage isEmbeddedPicker/>;
}

export default EmbeddedTicketPicker;
